//Reset data
export const RESET = "CONVERSATION_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "CONVERSATION_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CONVERSATION_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CONVERSATION_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CONVERSATION_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "CONVERSATION_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CONVERSATION_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CONVERSATION_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CONVERSATION_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CONVERSATION_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CONVERSATION_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "CONVERSATION_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CONVERSATION_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CONVERSATION_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CONVERSATION_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "CONVERSATION_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "CONVERSATION_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CONVERSATION_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CONVERSATION_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CONVERSATION_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "CONVERSATION_DEL_SET_IS_UPDATE"